import React from 'react'
import { Title } from '../title/title.jsx'

export const FormsAndAppFilter = ({
  filters,
  selectedFilter,
  setSelectedFilter,
  inputValue,
  setInputValue,
}) => {
  const onFilterClick = (i) => {
    let result = [...selectedFilter]
    if (selectedFilter?.includes(i)) {
      result = selectedFilter?.filter((f) => f !== i)
    } else {
      result.push(i)
    }
    setSelectedFilter(result)
  }

  return (
    <div className="u-marginTop3gu u-sm-marginTop15gu u-marginBottom5gu">
      {/* search */}
      <div
        className={
          'u-flex u-flexAlignItemsCenter u-flexAuto u-md-size1of2 u-lg-size1of2 u-bgColorWhite u-marginVert5gu'
        }
      >
        <div className="u-posRelative u-flexAuto u-paddingBottom2gu">
          <span
            className={
              'Icon--material input-search-icon u-posAbsolute u-textSizeMsrp2 u-textColorBrand'
            }
            style={{ top: '12px' }}
            aria-hidden="true"
          >
            &#xE8B6;
          </span>
          <input
            type="text"
            placeholder="Search Forms and Applications"
            className={
              'Input Input--withIcon Icon--before MutualFunds-searchField u-borderColorNeutralLight u-borderBottom u-borderTop0 u-borderLeft0 u-borderRight0'
            }
            value={inputValue}
            onChange={(e) => setInputValue(e.currentTarget.value)}
          />
          <div
            id={'clearSearch'}
            className="u-posAbsolute u-padding2gu"
            style={{ cursor: 'pointer', top: '0', right: 0 }}
            onClick={() => setInputValue('')}
          >
            <span
              id="cti-navigation-search-clear"
              className={'Icon--material input-close-icon'}
              aria-hidden="true"
            >
              &#xE5CD;
            </span>
          </div>
        </div>
      </div>
      <div className="u-marginTop5gu u-flex u-flexAlignItemsCenter u-flexAuto">
        {/* title */}
        <Title text="Filter by:" mode="medium-large" />

        {/* filter - chips */}
        <div
          className="u-paddingLeft5gu Chip-group"
          style={{ userSelect: 'none' }}
        >
          {filters?.map((i) => (
            <div
              key={i}
              className={`Chip ${
                selectedFilter?.includes(i) ? 'Chip--color active' : ''
              } u-marginRight2gu u-textCapitalize`}
              style={{ cursor: 'pointer', userSelect: 'none' }}
              onClick={() => onFilterClick(i)}
            >
              {i.replaceAll('-', ' ')}
            </div>
          ))}
        </div>
        <div className="u-paddingHoriz2gu u-paddingTop2gu u-textRight">
          <span
            className={`Link HeaderLinks-link ${
              selectedFilter.length === 0 ? 'u-disabled' : ''
            }`}
            style={selectedFilter.length === 0 ? { cursor: 'not-allowed' } : {}}
            onClick={() => setSelectedFilter([])}
          >
            Clear all filters
          </span>
        </div>
      </div>
    </div>
  )
}
